import React from 'react'

const Contactus = () =>{
    return (
        <h1 className="text-center">Coming Soon</h1>
    )
}

export default Contactus